import type { RouteRecordRaw } from 'vue-router'

const customerRoutes: RouteRecordRaw[] = [
  {
    path: 'customers',
    name: 'Customers',
    component: () => import('@/views/Customers.vue'),
    meta: { title: '客户管理' },
  },
  {
    path: 'customers/duplicates',
    name: 'CustomerDuplicateList',
    component: () => import('@/pages/customers/duplicates/index.vue'),
    meta: { title: '微信重粉统计' },
  },
  {
    path: 'customers/customer-duplicates',
    name: 'CustomerDataDuplicateList',
    component: () => import('@/pages/customers/duplicates/index.vue'),
    meta: { title: '微信重粉统计' },
  },
  {
    path: 'customers/:id',
    name: 'CustomerDetail',
    component: () => import('@/pages/customers/detail.vue'),
    meta: { title: '客户详情' },
  },
]

export default customerRoutes
